"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlotPositionsInnerToJSON = exports.SlotPositionsInnerFromJSONTyped = exports.SlotPositionsInnerFromJSON = exports.instanceOfSlotPositionsInner = exports.SlotPositionsInnerPositionEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.SlotPositionsInnerPositionEnum = {
    Preroll: 'PREROLL',
    Midroll: 'MIDROLL',
    Postroll: 'POSTROLL'
};
/**
 * Check if a given object implements the SlotPositionsInner interface.
 */
function instanceOfSlotPositionsInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSlotPositionsInner = instanceOfSlotPositionsInner;
function SlotPositionsInnerFromJSON(json) {
    return SlotPositionsInnerFromJSONTyped(json, false);
}
exports.SlotPositionsInnerFromJSON = SlotPositionsInnerFromJSON;
function SlotPositionsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'position': !(0, runtime_1.exists)(json, 'position') ? undefined : json['position'],
        'adBreakIndex': !(0, runtime_1.exists)(json, 'ad_break_index') ? undefined : json['ad_break_index'],
    };
}
exports.SlotPositionsInnerFromJSONTyped = SlotPositionsInnerFromJSONTyped;
function SlotPositionsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'position': value.position,
        'ad_break_index': value.adBreakIndex,
    };
}
exports.SlotPositionsInnerToJSON = SlotPositionsInnerToJSON;
